import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { environment } from '../../../../environments/environment';
import { EventService } from '../../../service/event.service';
import { SwalService } from '../../../service/swal.service';
import { EventDetailStore } from '../event-detail.store';
import { IconComponent } from '../../../components/icon/icon.component';

@Component({
  selector: 'app-documenti-tab',
  templateUrl: './documenti-tab.component.html',
  styleUrls: ['./documenti-tab.component.css'],
  imports: [CommonModule, FormsModule, TranslatePipe, NgxDropzoneModule, IconComponent],
})
export class DocumentiTabComponent {
  selectedDocs: File[] = [];
  isUploadingDocs = false;
  editingDocKey: string | null = null;
  editDocName = '';
  editDocNote = '';
  isSavingDoc = false;

  constructor(
    public store: EventDetailStore,
    private ms: EventService,
    private swal: SwalService,
  ) {}

  get event(): any { return this.store.event; }

  onSelectDoc(e: any) {
    this.selectedDocs.push(...e.addedFiles);
  }

  onRemoveDoc(file: File) {
    this.selectedDocs = this.selectedDocs.filter((f) => f !== file);
  }

  getDocumentUrl(key: string): string {
    return `${environment.apiUrl}/events/${this.store.eventId}/document?key=${encodeURIComponent(key)}`;
  }

  uploadDocuments() {
    if (!this.selectedDocs.length) return;
    this.isUploadingDocs = true;
    this.ms.uploadDocumenti(
      this.store.eventId!,
      this.selectedDocs,
      (data: any) => {
        if (data?.document) this.event.document = data.document;
        this.selectedDocs = [];
        this.isUploadingDocs = false;
        this.swal.success('Documenti caricati!');
      },
      () => {
        this.isUploadingDocs = false;
        this.swal.errorDialog('Errore', 'Caricamento documenti fallito');
      },
    );
  }

  startEditDoc(doc: any) {
    this.editingDocKey = doc.key;
    this.editDocName = doc.name ?? '';
    this.editDocNote = doc.note ?? '';
  }

  cancelEditDoc() {
    this.editingDocKey = null;
    this.editDocName = '';
    this.editDocNote = '';
  }

  saveDoc(doc: any) {
    const name = this.editDocName.trim();
    if (!name) {
      this.swal.errorDialog('Errore', 'Il nome non può essere vuoto');
      return;
    }
    this.isSavingDoc = true;
    this.ms.updateDocumento(
      this.store.eventId!,
      doc.key,
      { name, note: this.editDocNote.trim() },
      (data: any) => {
        if (data?.document) this.event.document = data.document;
        this.isSavingDoc = false;
        this.cancelEditDoc();
        this.swal.success('Documento aggiornato');
      },
      () => {
        this.isSavingDoc = false;
        this.swal.errorDialog('Errore', 'Aggiornamento documento fallito');
      },
    );
  }

  deleteDocument(doc: any) {
    this.swal
      .confirm('Elimina documento', `Eliminare "${doc.name}"?`)
      .then((result) => {
        if (!result.isConfirmed) return;
        this.ms.deleteDocumento(
          this.store.eventId!,
          doc.key,
          (data: any) => {
            if (data?.document) this.event.document = data.document;
            this.swal.success('Documento eliminato');
          },
          () => this.swal.errorDialog('Errore', 'Eliminazione documento fallita'),
        );
      });
  }
}
